import { Card } from "@/app/admin/_common/ui/card";
import { formatUtcDateTime } from "@/app/_utils/dayjs";
import type { GuestKpis } from "@/app/_services/GuestService";

const currencyFormat = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});
const numberFormat = new Intl.NumberFormat("en-US");

export default function GuestDetailKpiRow({ kpis }: { kpis: GuestKpis }) {
  const tiles = [
    {
      label: "Waitlist position",
      value: kpis.position != null ? `#${numberFormat.format(kpis.position)}` : "—",
      caption: kpis.joined_date ? `Joined ${formatUtcDateTime(kpis.joined_date, "MMM D, YYYY")}` : "—",
    },
    {
      label: "Signups",
      value: numberFormat.format(kpis.signups_count),
      caption: `Across ${kpis.shows_attended} ${kpis.shows_attended === 1 ? "show" : "shows"}`,
    },
    {
      label: "Shows attended",
      value: numberFormat.format(kpis.shows_attended),
      caption: kpis.check_in_rate != null ? `${Math.round(kpis.check_in_rate * 100)}% check-in rate` : "—",
    },
    {
      label: "Lifetime spend",
      value: currencyFormat.format(kpis.lifetime_spend),
      caption: `${kpis.orders_count} ${kpis.orders_count === 1 ? "order" : "orders"}`,
    },
  ];

  return (
    <div className="grid grid-cols-2 gap-2.5 sm:grid-cols-4">
      {tiles.map((tile) => (
        <Card key={tile.label} className="rounded-md p-3.5 shadow-none">
          <div className="mb-1 text-[11.5px] font-medium text-muted-foreground">{tile.label}</div>
          <div className="text-[21px] font-bold leading-none tracking-tight text-foreground">
            {tile.value}
          </div>
          <div className="mt-1.5 text-[11.5px] text-muted-foreground/70">{tile.caption}</div>
        </Card>
      ))}
    </div>
  );
}
